// Shared London-time despatch messaging for landing and product pages.
  (() => {
    document.querySelectorAll('[data-dispatch-countdown]').forEach((countdown) => {

      if (!countdown) {
        return;
      }

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const timeZone = countdown.dataset.timeZone || 'Europe/London';
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
      });

      const closedDates = new Set((countdown.dataset.dispatchClosedDates || '').split(/[\s,]+/).filter(Boolean));
      // Date overrides are available only on the development store.
      const previewDate = countdown.dataset.dispatchPreviewEnabled === 'true'
        ? new URLSearchParams(window.location.search).get('dispatch_preview')
        : null;
      const previewNow = previewDate && Number.isFinite(Date.parse(previewDate)) ? new Date(previewDate) : null;
      const dateKey = (date) => date.toISOString().slice(0, 10);
      const isDispatchDay = (date) => ![0, 6].includes(date.getUTCDay()) && !closedDates.has(dateKey(date));
      const nextDispatchMessage = (today) => {
        const next = new Date(today);
        for (let days = 1; days <= 366; days += 1) {
          next.setUTCDate(next.getUTCDate() + 1);
          if (!isDispatchDay(next)) continue;
          if (days === 1 && isDispatchDay(today)) return 'Order now for despatch tomorrow';
          const day = new Intl.DateTimeFormat('en-GB', { weekday: 'long', timeZone: 'UTC' }).format(next);
          return `Order now for despatch ${day}`;
        }
        return 'Despatch resumes after our scheduled closure';
      };

      let digitElements = [];
      let renderedTimer = false;
      let previousValue = '';

      const getPart = (parts, type) => Number(parts.find((part) => part.type === type)?.value || 0);
      const formatRemaining = (minutes) => {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;

        return `${String(hours).padStart(2, '0')}:${String(remainingMinutes).padStart(2, '0')}`;
      };
      const createElement = (tagName, className, text) => {
        const element = document.createElement(tagName);
        element.className = className;

        if (text) {
          element.textContent = text;
        }

        return element;
      };
      const createDigit = (digit) => {
        const element = createElement('span', 'landing-countdown__digit');
        const current = createElement('span', 'landing-countdown__digit-current', digit);
        const next = createElement('span', 'landing-countdown__digit-next', digit);

        element.dataset.value = digit;
        element.append(current, next);

        return element;
      };
      const renderTimeValue = (time, value) => {
        time.replaceChildren();
        digitElements = [];

        for (const character of value) {
          const element = /\d/.test(character)
            ? createDigit(character)
            : createElement('span', character === ' ' ? 'landing-countdown__space' : 'landing-countdown__static', character);

          time.append(element);

          if (/\d/.test(character)) {
            digitElements.push(element);
          }
        }
      };
      const renderTimer = (value) => {
        const visualMessage = createElement('span', 'landing-hero__dispatch-visual');
        const prefix = createElement('span', 'landing-hero__dispatch-prefix', 'Order in the next');
        const time = createElement('span', 'landing-countdown');
        const timeGroup = createElement('span', 'landing-hero__dispatch-time');
        timeGroup.append(time);
        const suffix = createElement('span', 'landing-hero__dispatch-suffix', ' for despatch today');
        const announcement = createElement('span', 'landing-hero__dispatch-announcement');

        time.setAttribute('aria-hidden', 'true');
        visualMessage.setAttribute('aria-hidden', 'true');
        visualMessage.append(prefix, timeGroup, suffix);
        countdown.replaceChildren(visualMessage, announcement);
        countdown.classList.add('landing-hero__dispatch-message--timer');
        renderTimeValue(time, value);
        renderedTimer = true;
      };
      const renderFallback = (message) => {
        if (!renderedTimer && countdown.textContent === message) return;
        countdown.classList.remove('landing-hero__dispatch-message--timer');
        countdown.textContent = message;
        digitElements = [];
        previousValue = '';
        renderedTimer = false;
      };
      const updateDigit = (element, nextValue, animate) => {
        if (element.dataset.value === nextValue) {
          return false;
        }

        const current = element.querySelector('.landing-countdown__digit-current');
        const next = element.querySelector('.landing-countdown__digit-next');

        if (!current || !next) {
          return false;
        }

        if (!animate) {
          current.textContent = nextValue;
          next.textContent = nextValue;
          element.dataset.value = nextValue;
          return false;
        }

        next.textContent = nextValue;
        element.classList.remove('is-stepping');
        element.offsetWidth;
        element.classList.add('is-stepping');

        window.setTimeout(() => {
          current.textContent = nextValue;
          next.textContent = nextValue;
          element.dataset.value = nextValue;
          element.classList.remove('is-stepping');
        }, 260);

        return true;
      };
      const updateDigits = (value) => {
        if (!renderedTimer) {
          renderTimer(value);
        }

        if (previousValue && previousValue.replace(/\d/g, '#') !== value.replace(/\d/g, '#')) {
          renderTimer(value);
          previousValue = value;
          return;
        }

        const digits = value.match(/\d/g) || [];
        const shouldAnimate = previousValue !== '' && !reducedMotion.matches;

        digitElements.forEach((element, index) => {
          updateDigit(element, digits[index], shouldAnimate);
        });

        previousValue = value;
      };
      const updateAnnouncement = (message) => {
        const announcement = countdown.querySelector('.landing-hero__dispatch-announcement');

        if (announcement && announcement.textContent !== message) {
          announcement.textContent = message;
        }
      };

      const updateCountdown = () => {
        const parts = formatter.formatToParts(previewNow || new Date());
        // Treat the London calendar date as UTC for calendar arithmetic only.
        const today = new Date(Date.UTC(getPart(parts, 'year'), getPart(parts, 'month') - 1, getPart(parts, 'day')));
        const secondsUntilNoon =
          12 * 60 * 60 - (getPart(parts, 'hour') * 60 * 60 + getPart(parts, 'minute') * 60 + getPart(parts, 'second'));

        if (!isDispatchDay(today) || secondsUntilNoon <= 0) {
          renderFallback(nextDispatchMessage(today));
          return;
        }

        const remaining = formatRemaining(Math.ceil(secondsUntilNoon / 60));
        const message = `Order in the next ${remaining} for despatch today`;

        if (countdown.dataset.dispatchTextOnly === 'true') {
          if (countdown.textContent !== message) countdown.textContent = message;
        } else {
          updateDigits(remaining);
          updateAnnouncement(message);
        }
      };

      updateCountdown();
      window.setInterval(updateCountdown, 1000);
    });
  })();
